export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-add-192ac16b741d7c6da9fd568f63d8710b.svg";